<template>
  <div class="table-view" @click.stop>
    <hs-scroll ref="tableView" :data="[]" class="table-view-horizontal" direction="horizontal">
      <div class="notice-tab-list" style="min-height: 0">
        <div
          class="item"
          :class="{'active': selected.indexOf(i) >= 0}"
          v-for="(item, i) in list"
          :key="i"
        >{{getAirPortName(item) ? getAirPortName(item) : getCityName(item) }}<div class="delete" @click="$emit('delete', i)">x</div></div>
        <div ref="tableViewRight" style="width: 0"></div>
      </div>
    </hs-scroll>
  </div>
</template>
<script type="text/ecmascript-6">
/**
 * 地址选择器顶部搜索框 城市
 */
export default {
  props: {
    list: {
      type: Array,
      default: () => {
        return []
      }
    },
    selected: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  watch: {
    'list.length'(newVal, oldVal) {
      if (newVal > oldVal) {
        if (this.$refs.tableView && this.$refs.tableViewRight) {
          setTimeout(() => {
            this.$refs.tableView && this.$refs.tableView.scrollToElement(this.$refs.tableViewRight, 100)
          }, 100)
        }
      }
    }
  },
  components: {
    HsScroll: () => import('base/hs-scroll/hs-scroll')
  }
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
.table-view
  max-width 60%
  overflow hidden
  flex-shrink 0
.table-view-horizontal
  @extend .flex-row
  @extend .flex-start
  width 100%
  height 100%
  overflow hidden
.notice-tab-list
  @extend .flex-start
  width 100%
  height 29px
  white-space nowrap
  .item
    @extend .flex-center
    flex-shrink 0
    height 30px
    padding-left 7px
    border-radius 4px
    background $color_background_block_5
    margin-right 6px
    font-size 13px
    color $color_theme
    >.delete
      @extends .flex-center
      padding 0 7px
      height 100%
  .active
    color $color_theme
    border 1px solid $color_theme
</style>
